import { useLogin } from '@/providers/login/LoginProvider';
import React from 'react';
import { ContactDetailsForm } from '@/components/SummaryContactDetails/ContactDetailsForm';

export const PrimeAcquisitionForm = ({
  data,
  onBlur,
  showErrors,
  formFields,
}) => {
  const { isLogged } = useLogin();

  return (
    <ContactDetailsForm
      data={data}
      onBlur={onBlur}
      showErrors={showErrors}
      emailDisabled={isLogged}
      formDisabled={false}
      formFields={formFields}
    />
  );
};
